import { AppBarGuardType, AppBarGuardObjectType } from '../type';

export const name = 'isTargetOpenExpanded';

export const fn: AppBarGuardType = (context) => context.target === 'openExpanded';

export const guard: AppBarGuardObjectType = {
  [name]: fn,
};

export default guard;
